const DICTIONARY_PATH: string = '/dictionaries';
const CREATE_NEW_DICTIONARY_VIEW_PATH: string = `${DICTIONARY_PATH}/new`;
const CREATE_NEW_DICTIONARY_PATH: string = `${DICTIONARY_PATH}/create-dictionary`;
const PREDICT_DICTIONARY_PATH: string = `${CREATE_NEW_DICTIONARY_VIEW_PATH}/predict-dictionary`;
const UPDATE_DICTIONARY_PATH: string = `${DICTIONARY_PATH}/:dictionaryId`;

export const DICTIONARY_PATHS = {
    LANDING_PAGE: DICTIONARY_PATH,
    CREATE_NEW_DICTIONARY_VIEW: CREATE_NEW_DICTIONARY_VIEW_PATH,
    CREATE_NEW_DICTIONARY: CREATE_NEW_DICTIONARY_PATH,
    UPDATE_DICTIONARY: UPDATE_DICTIONARY_PATH,
    PREDICT_DICTIONARY: PREDICT_DICTIONARY_PATH,
};
